import React from "react";
import Colors from "../../Constants/Colors";

const QuestionTypeSelector = ({ selectedType, onChange }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
        paddingTop: "15px",
      }}
    >
      <label style={{ fontWeight: 500, marginRight: "80px", fontSize: "16px" }}>
        Type:
      </label>
      <div style={{ display: "flex", gap: "80px" }}>
        {["Single Select", "Multi Select", "Fill-In the Blanks", "Boolean"].map(
          (type, index) => (
            <label
              key={index}
              style={{ display: "flex", alignItems: "center", gap: "4px" }}
            >
              <input
                type="radio"
                value={type}
                checked={selectedType === type}
                onChange={() => onChange(type)}
                disabled
                style={{
                  color: `${Colors.color1}`,
                  backgroundColor: `${Colors.color5}`,
                }}
              />
              <div style={{ marginLeft: "8px" }}>{type}</div>
            </label>
          )
        )}
      </div>
    </div>
  );
};

export default QuestionTypeSelector;
